<template>
  <div class="lotti-nav">

    <div class="lotti-logo">
      <div class="lotti-logo-img">

        <svg width="43" height="45" viewBox="0 0 43 45" fill="none" xmlns="http://www.w3.org/2000/svg">

          <circle cx="21.5676" cy="22.5" r="17" fill="white"/>
          <circle cx="21.5676" cy="22.5" r="18.95" stroke="url(#paint00_linear)" stroke-width="5.00468"/>
          
          <path class="lotti-hand-hours" style="transform-origin: center center;" d="M14.4758 22.4536L21.5676 22.4536" stroke="url(#paint01_linear)" stroke-width="5.00468" stroke-linecap="round"/>
          <path class="lotti-hand-minutes" style="transform-origin: center center;" d="M21.5677 22.4997L21.5678 10.583" stroke="url(#paint02_linear)" stroke-width="5.00468" stroke-linecap="round"/>

          <defs>
            <linearGradient id="paint00_linear" x1="9.10281" y1="11.6701" x2="34.3753" y2="30.8722" gradientUnits="userSpaceOnUse">
              <stop stop-color="#865DFF"/>
              <stop offset="1" stop-color="#50BF6A"/>
            </linearGradient>
            <linearGradient id="paint01_linear" x1="16.6135" y1="15.6206" x2="24.2447" y2="22.4682" gradientUnits="userSpaceOnUse">
              <stop stop-color="#50BF6A"/>
              <stop offset="1" stop-color="#865DFF"/>
            </linearGradient>
            <linearGradient id="paint02_linear" x1="22" y1="23.5" x2="22.5407" y2="7.51829" gradientUnits="userSpaceOnUse">
              <stop stop-color="#50BF6A"/>
              <stop offset="1" stop-color="#865DFF"/>
            </linearGradient>
          </defs>
        </svg>

      </div>
      <span class="lotti-title">Lotti</span>
    </div>

    <div class="lotti-menu-bar" v-if="auth.user.authenticated">

      <router-link :to="{ name: 'home' }" class="lotti-menu-item" :class="activeClass('home')">
        <i class="el-icon-house"></i> Home
        <div class="lotti-menu-item-rounded"></div>
      </router-link>

      <router-link :to="{ name: 'profile' }" class="lotti-menu-item" :class="activeClass('profile')">
        <i class="el-icon-user"></i> Profil
        <div class="lotti-menu-item-rounded"></div>
      </router-link>

      <router-link :to="{ name: 'weekly' }" class="lotti-menu-item" :class="activeClass('weekly')">
        <i class="el-icon-date"></i> Wochenlektionen
        <div class="lotti-menu-item-rounded"></div>
      </router-link>

      <router-link v-if="auth.user.profile.permissions.is_leader" :to="{ name: 'lead' }" class="lotti-menu-item" :class="activeClass('lead')">
        <i class="el-icon-magic-stick"></i> Leitung
        <div class="lotti-menu-item-rounded"></div>
      </router-link>

      <router-link v-if="auth.user.profile.permissions.is_admin" :to="{ name: 'admin' }" class="lotti-menu-item" :class="activeClass('admin')">
        <i class="el-icon-cpu"></i> Admin
        <div class="lotti-menu-item-rounded"></div>
      </router-link>

      <div class="lotti-menu-item" @click="signout()">
        <i class="el-icon-switch-button"></i> Logout
        <div class="lotti-menu-item-rounded"></div>
      </div>

    </div>

    <div class="lotti-nav-user">
      <div class="lotti-nav-user-text" v-if="auth.user.authenticated">
        <span class="lotti-nav-user-name">{{ auth.user.profile.firstName }} {{ auth.user.profile.lastName }}</span>
        <span class="lotti-nav-user-district">{{ auth.user.profile.serviceName }}</span>
      </div>
      <div class="lotti-nav-user-icon" v-show="auth.user.authenticated"></div>
    </div>

  </div>
</template>

<script>
import auth from '../../auth.js'
import {router} from '../../main.js';
import clockHelper from '../../Helpers/ClockHelper.js';
import { hashicon } from '@emeraldpay/hashicon';

export default {

  data() {
    return {
      auth: auth,
      clockHelper: clockHelper,
      //router: router,//other option would be without import but directly with $router

      clockTickTimeout: null,
    }
  },

  methods: {

    signout() {
      auth.signout()
    },

    activeClass(pathName) {
      return this.$route.name === pathName ? 'lotti-menu-icon-active': '';
    },

  },

  mounted() {

    //initialize clocks (in nav and signin screen)
    this.clockHelper.setClock();
    this.clockTickTimeout = setInterval(() => {
      this.clockHelper.setClock();
    }, 60 * 1000);
  },

  watch: {
    auth: {
      //on change of auth obj, the hashicon gets attached to the navbar
      handler(newAuth, oldAuth) {
        if (newAuth.user.authenticated) {

          //append hashicon only if user authenticated
          const icon = hashicon(newAuth.user.profile.firstName + ' ' + newAuth.user.profile.lastName, 100);//generate canvas icon for 100px
          icon.setAttribute("style", "width: 50px; height: 50px");//scale it down to 50px
          let el = document.getElementsByClassName('lotti-nav-user-icon')[0];
          el.innerHTML = '';
          el.appendChild(icon);
        }
      },
      deep: true
    }
  },

  beforeDestroy() {
    //to be sure timeouts are cleared
    clearInterval(this.clockTickTimeout);
  },
}

</script>